<template>
    <div :class="[
        'component',
        'component__thumbnail',
        thumbnailSize ? `component__thumbnail--size-${thumbnailSize}` : '',
        error ? `component__thumbnail--error` : ''
    ]">
        <div
            class="component__thumbnail_box"
            @click="performClick"
        >
            <template v-if="url || id">
                <div class="component__thumbnail_box_image">
                    <component-image
                        :id="id"
                        :url="url"
                        :alt="alt"
                        :size="imageSize"
                        :full-height="true"
                    ></component-image>
                </div>
            </template>
            <template v-else-if="loading">
                <div class="component__thumbnail_box_loading">
                    <component-loading/>
                </div>
            </template>
            <template v-else-if="error">
                <div class="component__thumbnail_box_error">
                    <v-icon name="x-circle"/>
                </div>
            </template>
            <template v-else>
                <div class="component__thumbnail_box_blank">
                    <img
                        :src="require('@/assets/img/image-blank.svg')"
                        :alt="alt"
                    >
                </div>
            </template>
        </div>
        <pop-image
            ref="popimage"
        />
    </div>
</template>

<script>
import ComponentLoading from '@/components/default/shared/ComponentLoading'
import PopImage from '@/components/default/shared/PopImage'
import ComponentImage from '@/components/default/shared/ComponentImage'

export default {
  name: 'component-thumbnail',
  components: { ComponentImage, PopImage, ComponentLoading },
  props: {
    id: {
      type: String
    },
    url: {
      type: String
    },
    alt: {
      type: String
    },
    thumbnailSize: {
      // one of ['small', 'medium', 'large', 'full']
      type: String,
      default: 'small'
    },
    imageSize: {
      // one of ['small', 'medium', 'original']
      type: String
    },
    popImageSize: {
      // one of ['small', 'medium', 'original']
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    allowPreview: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    performClick () {
      if (this.allowPreview) {
        if (this.id || this.url) {
          if (this.id) {
            this.$refs.popimage.setId(this.id)
          } else if (this.url) {
            this.$refs.popimage.setUrl(this.url)
          }
          this.$refs.popimage.setSize(this.popImageSize)
          this.$refs.popimage.setAlt(this.alt)
          this.$refs.popimage.openNotify()
        }
      }
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/_componentthumbnail.scss";
</style>
